import { Outlet } from "react-router-dom";
import Header, { Footer } from "./Header";
import BackToTop from "./BackToTop";
import { Toaster } from "./ui/sonner";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}
